var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.33333C4.2 -0.777778 13.8 -0.777778 17 6.33333",
    stroke: "#0F2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9987 9.889C8.64851 9.889 8.30174 9.82002 7.97821 9.68601C7.65467 9.552 7.3607 9.35557 7.11308 9.10795C6.86546 8.86033 6.66903 8.56635 6.53502 8.24282C6.40101 7.91929 6.33203 7.57252 6.33203 7.22233C6.33203 6.87214 6.40101 6.52538 6.53502 6.20184C6.66903 5.87831 6.86546 5.58434 7.11308 5.33671C7.3607 5.08909 7.65467 4.89266 7.97821 4.75865C8.30174 4.62464 8.64851 4.55566 8.9987 4.55566C9.70594 4.55566 10.3842 4.83662 10.8843 5.33671C11.3844 5.83681 11.6654 6.51509 11.6654 7.22233C11.6654 7.92957 11.3844 8.60785 10.8843 9.10795C10.3842 9.60805 9.70594 9.889 8.9987 9.889Z",
    fill: "#0F2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.1a7defc92ee9249d2984b914269d79e3.svg";
export { ForwardRef as ReactComponent };